<template>
  <span
    class="selection-check"
    aria-hidden="true">
    <svg
      width="10"
      height="10"
      viewBox="0 0 12 12"
      fill="none">
      <path
        d="M2 6l2.5 2.5L10 3.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </span>
</template>

<style scoped>
.selection-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--accent-green);
  color: #fff;
  flex-shrink: 0;
}
</style>
